<template>
    <div class="customer-dashboard">
			<div class="p-4">
					<iframe class="responsive-iframe" src="https://app.powerbi.com/view?r=eyJrIjoiOTM5ZmNlNmYtZmFlMy00MGI5LThlZTctNTI5OGM3YmIzYTNiIiwidCI6IjQxOTgwZDg5LWY2ZDUtNDdmNy04MmI0LWM3ZjYwMzliZDBlYyIsImMiOjEwfQ%3D%3D" frameborder="0" allowFullScreen="true" style="min-height:2100px; width:100%; overflow-y: hidden;" scrolling="no"></iframe>
			</div>
    </div>
</template>
<script>
import { useAuthStore } from '@/stores/authStore'
import { mapState } from 'pinia'

export default {
    computed:{
        ...mapState(useAuthStore, ['auth_user'])
    },
}
</script>